import React from 'react';
import Caret from '../components/Caret';
import IconButton from '../components/IconButton';
import useMainContentHistory from '../utils/router/useMainContentHistory';

const BackButton = () => {
  const history = useMainContentHistory();
  const handleClick = () => {
    history.back();
  };

  return (
    <IconButton onClick={handleClick} aria-label="Back">
      <Caret direction="left" size="large" />
    </IconButton>
  );
};

export default BackButton;
